export const getDownloadFilename = (res: Response, defaultFileName: string): string => {
  const contentDisposition = res.headers.get("Content-Disposition")
  if (!contentDisposition) return defaultFileName

  const utf8FileName = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  if (utf8FileName) {
    return decodeURIComponent(utf8FileName)
  }

  const fileName = contentDisposition.match(/filename="?([^";]+)"?/i)?.[1]
  return fileName || defaultFileName
}

export const saveDownloadedFile = ({
  blob,
  fallbackFileName,
  fileName
}: {
  blob: Blob
  fallbackFileName: string
  fileName?: string
}) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")

  link.href = url
  link.download = fileName || fallbackFileName

  document.body.appendChild(link)
  link.click()
  link.remove()

  window.setTimeout(() => {
    window.URL.revokeObjectURL(url)
  }, 0)
}
